/**
 * Offline fixture for REACT_APP_PRESENTATION_THEMES_API=mock and tests —
 * mirrors the backend contract (shape only; real themes come from the file).
 */
import type { PresentationThemeListApi } from "./presentationThemes.types";

export const MOCK_PRESENTATION_THEMES: PresentationThemeListApi = {
  default_theme: "magicbi",
  themes: [
    { key: "magicbi", label: "MagicBI Light", palette: { purplePrimary: "#5B21B6" }, tone: "light" },
    { key: "contoso", label: "Contoso", palette: { purplePrimary: "#2050CC" }, tone: "light" },
    { key: "magicbi-dark", label: "MagicBI Dark", palette: { purplePrimary: "#8063C5", slideBackground: "#15111F" }, tone: "dark" },
  ],
};

export const mockFetchPresentationThemes = async (): Promise<PresentationThemeListApi> =>
  JSON.parse(JSON.stringify(MOCK_PRESENTATION_THEMES));
